import type { MaybeRefOrGetter } from 'vue'

import type { Config } from '../@types/editor'

type DeletablePlaysStore = {
  canDeleteAllPlays: (config: Config) => boolean
  deleteAllPlays: (config: Config) => void
}

export const useDeleteAllPlays = (
  store: DeletablePlaysStore,
  configRef: MaybeRefOrGetter<Config | null>,
) => {
  const { scrollTop } = useScrollUtils()
  const { animated, withoutAnimation } = useEditorPlayListAnimation()

  const config = computed(() => toValue(configRef))

  const canDeleteAllPlays = computed(() => !!config.value && store.canDeleteAllPlays(config.value))

  const deleteAllPlays = async () => {
    const currentConfig = config.value
    if (!currentConfig) return

    withoutAnimation(() => store.deleteAllPlays(currentConfig))

    await nextTick()
    scrollTop(0, 'instant')
  }

  return { animated, canDeleteAllPlays, deleteAllPlays }
}
